import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';
import { ArrayUtils } from '../../Utils/ArrayUtils';

var tableId = 'tableRequestLog';
var tableDom = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface DetailPageOptions extends PageOptionsBase {
    urlList: string;
}

export class DetailPage extends PageBase<DetailPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;

    constructor(options: DetailPageOptions) {
        super(options);

        this.createdRow = this.createdRow.bind(this);
        this.renderDetailRow = this.renderDetailRow.bind(this);
        this.renderContextData = this.renderContextData.bind(this);

        // === prepare table options
        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Id',
            autoWidth: true,
            columns: [
                {
                    data: 'Id',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnId${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Created',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnCreated${rowData.Id}'>${data || ''}</span>`),
                },
                {
                    data: 'Duration',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnDuration${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Action',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnAction${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Result',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnResult${rowData.Id}'>${data}</span>`)
                },
                {
                    data: 'Source',
                    render: (data: any, type: any, rowData: any) =>
                        (`<span id='spnSource${rowData.Id}'>${data}</span>`)
                }
            ],
            callbacks: {
                createdRow: this.createdRow
            },
            rowDetail: {
                hasDetail: true,
                render: this.renderDetailRow
            }
        };
    }

    init(): void {
        // == create 'new Datatable' instance
        this._table = new Datatable(tableId, this._tableOptions);
    }

    private createdRow(row: Node, data: any[] | Object, dataIndex: number): void {
        $('td', row).addClass('cursor-pointer');

        if (data["Result"] === 'Error') {
            $(row).addClass('error-log-row');
        }

        if (data["Result"] === 'Warning') {
            $(row).addClass('warning-log-row');
        }
    }

    private renderDetailRow(data: any): string {
        var css = 'info';
        if (data.Result === 'Warning') {
            css = 'warning';
        }
        if (data.Result === 'Error') {
            css = 'danger';
        }

        var result = `<div class='note note-${css}'>`;

        if (!StringUtils.isNullOrEmpty(data.ContextData)) {
            result += `<h5>Context</h5>
                    <p>${this.renderContextData(data.ContextData)}</p>
                    <p>&nbsp;</p>`;
        }

        if (!StringUtils.isNullOrEmpty(data.ExceptionData)) {
            result += `<h5>Exception</h5>
                    <p class="errorLogContextData">${_.escape(data.ExceptionData)}</p>
                    <p>&nbsp;</p>`;
        }

        if (!StringUtils.isNullOrEmpty(data.RequestData)) {
            result += `<h5>Request</h5>
                    <p class="errorLogContextData">${_.escape(data.RequestData)}</p>
                    <p>&nbsp;</p>`;
        }

        if (!StringUtils.isNullOrEmpty(data.ResponseData)) {
            result += `<h5>Response</h5>
                    <p class="errorLogContextData">${_.escape(data.ResponseData)}</p>
                    <p>&nbsp;</p>`;
        }

        result += '</div>';

        return result;
    }

    private renderContextData(contextData: string) {
        var json: Object = null;
        try {
            json = JSON.parse(contextData);
        } catch (e) {
            json = null;
        }

        var result = '';
        if (json === null || !_.isArray(json)) {
            result = contextData;
        } else {
            result = '<table class="errorLogContextData table-bordered table-hover">';
            _.each(json, item => {
                for (var key in item) {
                    result += `<tr><td>${key}</td><td>${StringUtils.escapeHtml(item[key])}</td></tr>`;
                }
            });

            result += '</table>';
        }

        return result;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/Logs/DetailPage.ts
 **/